(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/event-by-product-list-widget/assets/javascripts/extract-event-items.js') >= 0) return;  svs.modules.push('/components/sport/event-by-product-list-widget/assets/javascripts/extract-event-items.js');
"use strict";



const _getAllServerImports = () => {
  const path = require('path');
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  const trinidadRequire = trinidad.components.require;
  const localRequire = file => require(path.join(__dirname, file));
  return Object.freeze({
    getLogger: trinidad.logger,
    format: trinidadRequire('utils', 'format').api,
    formatDate: trinidadRequire('lb-utils', 'helper-formatdate').api.formatDate,
    urlMapping: trinidad.urlMapping,
    urlHelperMockable: trinidadRequire('lb-utils', 'helper-get-game-url').api,
    products: trinidadRequire('utils', 'products'),
    getRacingClassName: trinidadRequire('utils', 'racing').getRacingClassName,
    brandMapping: localRequire('../../../../lb-utils/brand-mapping/assets/javascripts/brand-mapping.es6'),
    racingConstants: localRequire('../../../../racing/common/assets/javascripts/constants.es6'),
    racingNavigation: localRequire('../../../../racing/race-navigation/assets/javascripts/location.es6'),
    racingServiceParse: localRequire('../../../../racing/race-service/assets/javascripts/utils/parse.es6')
  });
};
const _getAllClientImports = svs => Object.freeze({
  getLogger: svs.core.log.getLogger,
  format: svs.utils.format,
  formatDate: svs.components.lbUtils.helpers.formatDate.formatDate,
  urlMapping: svs.core.urlMapping,
  urlHelperMockable: svs.components.lbUtils,
  products: svs.utils.products,
  brandMapping: svs.components.lbUtils.brandMapping.fn,
  racingConstants: svs.racing.common.constants,
  racingNavigation: svs.racing.navigation.location,
  racingServiceParse: svs.racing.raceService.utils.parse,
  getRacingClassName: svs.utils.racing.getRacingClassName
});
const _ref = svs.isServer ? _getAllServerImports() : _getAllClientImports(svs),
  getLogger = _ref.getLogger,
  format = _ref.format,
  formatDate = _ref.formatDate,
  urlHelperMockable = _ref.urlHelperMockable,
  _ref$products = _ref.products,
  getProductClassName = _ref$products.getProductClassName,
  productIds = _ref$products.productIds,
  brandMapping = _ref.brandMapping,
  racingConstants = _ref.racingConstants,
  racingServiceParse = _ref.racingServiceParse,
  getRacingClassName = _ref.getRacingClassName;
const logger = getLogger('widget:event-by-product-list');
const PRODUCT_IDS_WITH_JACKPOT = [productIds.STRYKTIPSET, productIds.EUROPATIPSET, productIds.MALTIPSET];

async function extractEventItems(_ref2) {
  let target = _ref2.target,
    req = _ref2.req,
    response = _ref2.response,
    jackpotsResponse = _ref2.jackpotsResponse,
    cmsConfig = _ref2.cmsConfig,
    areaName = _ref2.areaName;
  switch (target) {
    case 'draws':
      {
        const bestDrawsByProduct = _getBestDrawsByProduct(response);
        const eventItems = Object.values(bestDrawsByProduct).map(async draw => _getRelevantDrawData({
          draw,
          jackpotsResponse,
          cmsConfig,
          areaName,
          req
        }));
        return await Promise.all(eventItems);
      }
    case 'racing':
      {
        return _extractRacing({
          response,
          req,
          jackpotsResponse,
          cmsConfig,
          areaName
        });
      }
    default:
      logger.info("Error in extractEventItems(): Invalid target \"".concat(target, "\""));
      return [];
  }
}

function _getBestDrawsByProduct(drawsResponse) {
  if (!drawsResponse) {
    return {};
  }
  const bestDrawsByProduct = {};
  drawsResponse.result.map(item => item.payload.draw).forEach(currDraw => {
    const productName = getProductClassName(currDraw.productId);
    const prevDraw = bestDrawsByProduct[productName];
    if (prevDraw) {
      const prevCloseTS = Date.parse(prevDraw.regCloseTime);
      const currCloseTS = Date.parse(currDraw.regCloseTime);
      const prevNetSale = parseInt(prevDraw.currentNetSale || prevDraw.currentNetSales, 10);
      const currNetSale = parseInt(currDraw.currentNetSale || currDraw.currentNetSales, 10);
      if (prevCloseTS < currCloseTS || prevCloseTS === currCloseTS && prevNetSale > currNetSale) {
        return;
      }
    }
    bestDrawsByProduct[productName] = currDraw;
  });
  return bestDrawsByProduct;
}

async function _getRelevantDrawData(_ref3) {
  let draw = _ref3.draw,
    jackpotsResponse = _ref3.jackpotsResponse,
    cmsConfig = _ref3.cmsConfig,
    areaName = _ref3.areaName,
    req = _ref3.req;
  if (!draw) {
    return null;
  }
  const branding = brandMapping.getProductBrand(draw.productId, null, draw.userProduct);
  const events = draw.drawEvents || draw.events || [];
  const productName = getProductClassName(draw.productId);
  const _mapCmsConfig2 = _mapCmsConfig({
      cmsConfig,
      productName
    }),
    extraSubTitle = _mapCmsConfig2.extraSubTitle;
  const _mapProductSpecificDa = _mapProductSpecificData({
      target: 'draws',
      itemData: draw,
      jackpotsResponse
    }),
    subTitle = _mapProductSpecificDa.subTitle,
    closeTime = _mapProductSpecificDa.closeTime,
    extraFund = _mapProductSpecificDa.extraFund,
    hasJackpot = _mapProductSpecificDa.hasJackpot,
    sortNetSale = _mapProductSpecificDa.sortNetSale;
  const subTitles = [closeTime, extraSubTitle, subTitle].filter(Boolean);
  const threeUniqueEvents = events.filter((item, index) => events.findIndex(item2 => {
    var _item$match, _item2$match;
    return ((_item$match = item.match) === null || _item$match === void 0 ? void 0 : _item$match.matchId) === ((_item2$match = item2.match) === null || _item2$match === void 0 ? void 0 : _item2$match.matchId);
  }) === index).filter(item => {
    var _item$match2, _item$match3;
    return Boolean(((_item$match2 = item.match) === null || _item$match2 === void 0 ? void 0 : _item$match2.participants[0]) && ((_item$match3 = item.match) === null || _item$match3 === void 0 ? void 0 : _item$match3.participants[1]));
  }).slice(0, 3);
  const infoRows = threeUniqueEvents.map(_ref4 => {
    let _ref4$match = _ref4.match,
      league = _ref4$match.league,
      participants = _ref4$match.participants;
    let homeName = participants[0].name;
    let awayName = participants[1].name;
    if (homeName.length + awayName.length >= 37) {
      homeName = participants[0].mediumName;
      awayName = participants[1].mediumName;
    }
    return {
      smallText: league.name,
      text: "".concat(homeName, " - ").concat(awayName)
    };
  });
  const gameUrl = await urlHelperMockable.getGameUrlServer({
    productId: draw.productId,
    drawNumber: draw.drawNumber,
    options: {
      req
    }
  });

  const item = {
    gameUrl,
    className: branding,
    brandLogo: branding,
    isHighFive: false,
    areaName,
    icon: cmsConfig.icon,
    subTitle: subTitles[0] || '',
    extraSubTitle: subTitles[1] || null,
    extraFund,
    hasJackpot,
    infoRows,
    footnote: events.length > 0 ? "".concat(infoRows.length, "/").concat(events.length, " objekt") : null,
    sortNetSale,
    sortTS: Date.parse(draw.regCloseTime)
  };
  return item;
}

function _extractRacing(_ref5) {
  var _response$result$, _meeting$track;
  let response = _ref5.response,
    req = _ref5.req,
    jackpotsResponse = _ref5.jackpotsResponse,
    cmsConfig = _ref5.cmsConfig,
    areaName = _ref5.areaName;
  const gaits = racingConstants.gaits;
  const raceItem = response === null || response === void 0 || (_response$result$ = response.result[0]) === null || _response$result$ === void 0 || (_response$result$ = _response$result$.payload) === null || _response$result$ === void 0 ? void 0 : _response$result$.race;
  if (!raceItem) {
    return [];
  }
  const results = [];
  const _mapCmsConfig3 = _mapCmsConfig({
      cmsConfig,
      productName: 'HighFive'
    }),
    extraSubTitle = _mapCmsConfig3.extraSubTitle;
  const _mapProductSpecificDa2 = _mapProductSpecificData({
      target: 'racing',
      itemData: raceItem,
      jackpotsResponse
    }),
    subTitle = _mapProductSpecificDa2.subTitle,
    closeTime = _mapProductSpecificDa2.closeTime,
    extraFund = _mapProductSpecificDa2.extraFund,
    hasJackpot = _mapProductSpecificDa2.hasJackpot,
    sortNetSale = _mapProductSpecificDa2.sortNetSale;
  const subTitles = [closeTime, extraSubTitle, subTitle].filter(Boolean);
  const parseDistance = racingServiceParse.parseDistance;
  const raceNumber = raceItem.raceNumber,
    raceName = raceItem.raceName,
    distance = raceItem.distance,
    distanceUnit = raceItem.distanceUnit,
    gait = raceItem.gait,
    startType = raceItem.startType,
    meeting = raceItem.meeting;
  const distanceText = distance > 1000 ? "".concat(Math.floor(distance / 1000), " ").concat(String(distance % 1000).padStart(3, '0')) : distance;
  const startTypeText = String(startType).toLowerCase() === 'undefined' ? '' : " ".concat(startType);
  const infoRows = [{
    smallText: 'Bana',
    text: meeting !== null && meeting !== void 0 && (_meeting$track = meeting.track) !== null && _meeting$track !== void 0 && _meeting$track.trackName && raceNumber ? "".concat(meeting.track.trackName, " Lopp ").concat(raceNumber) : null
  }, {
    smallText: 'Sport',
    text: gait ? {
      [gaits.GALLOP]: 'Galopp',
      [gaits.TROTTING]: 'Trav'
    }[gait.toLowerCase()] : null
  }, {
    smallText: 'Distans',
    text: distance && distanceUnit ? "".concat(parseDistance(distanceText, distanceUnit)).concat(startTypeText) : null
  }].filter(item => Boolean(item.text));
  const racingClassName = getRacingClassName(productIds.RACING);

  const item = {
    gameUrl: urlHelperMockable.getRacingGameUrl({
      race: raceItem,
      userProduct: 'Rx5io'
    }),
    className: racingClassName,
    brandLogo: "".concat(racingClassName, "-secondary"),
    isHighFive: true,
    areaName,
    icon: cmsConfig.icon,
    subTitle: subTitles[0],
    extraSubTitle: subTitles[1],
    extraFund,
    hasJackpot,
    infoRows,
    footnote: raceName && String(raceName).toLowerCase() !== 'undefined' ? raceName : null,
    sortNetSale,
    sortTS: Date.parse(raceItem.startTimeTentative)
  };
  results.push(item);
  return results;
}

function _mapCmsConfig(_ref6) {
  let cmsConfig = _ref6.cmsConfig,
    productName = _ref6.productName;
  const capitalizedName = "".concat(productName[0].toUpperCase()).concat(productName.slice(1));
  const subtitlePropName = "subtitle".concat(capitalizedName);
  const extraSubTitle = cmsConfig[subtitlePropName] ? cmsConfig[subtitlePropName] : '';
  return {
    extraSubTitle
  };
}

function _mapProductSpecificData(_ref7) {
  let target = _ref7.target,
    itemData = _ref7.itemData,
    jackpotsResponse = _ref7.jackpotsResponse;
  const isDraw = target === 'draws';
  const isRacing = target === 'racing';
  if (!isDraw && !isRacing) {
    logger.info("Error in _mapProductSpecificData() of extractEventItems(): Invalid target \"".concat(target, "\""));
    return {};
  }
  const closeTimeField = isDraw ? 'regCloseTime' : 'startTimeTentative';
  const closeTime = "Spelstopp: ".concat(formatDate(itemData[closeTimeField], true, true, true));
  let extraFund = _getJackpotText({
    isDraw,
    isRacing,
    itemData,
    jackpotsResponse
  });
  const hasJackpot = Boolean(extraFund);
  extraFund = extraFund || _getFundText({
    itemData
  }) || _getNetsaleText({
    isDraw,
    isRacing,
    itemData,
    jackpotsResponse
  });
  const subTitle = isDraw ? itemData.description || itemData.eventDescription : null;
  let sortNetSale = 0;
  if (isDraw) {
    sortNetSale = parseFloat(String(itemData.currentNetSale || itemData.currentNetSales || '0').replace(',', '.'));
  }
  if (isRacing) {
    const jackpotData = jackpotsResponse === null || jackpotsResponse === void 0 ? void 0 : jackpotsResponse.turnover;
    if (jackpotData && itemData.raceId === jackpotData.raceId) {
      sortNetSale = parseFloat(String(jackpotData.turnover).replace(',', '.'));
    }
  }
  return {
    closeTime,
    subTitle,
    extraFund,
    hasJackpot,
    sortNetSale
  };
}

function _getJackpotText(_ref8) {
  let isDraw = _ref8.isDraw,
    isRacing = _ref8.isRacing,
    itemData = _ref8.itemData,
    jackpotsResponse = _ref8.jackpotsResponse;
  const formatCurrencyInMillions = format.CurrencyInMillions;
  const hasJackpotSupport = isDraw ? PRODUCT_IDS_WITH_JACKPOT.includes(itemData.productId) : true;
  if (!hasJackpotSupport) {
    return null;
  }
  let jackpotAmount;
  if (isDraw) {
    var _jackpot$jackpots;
    const jackpot = jackpotsResponse === null || jackpotsResponse === void 0 ? void 0 : jackpotsResponse.jackpots.find(item => item.drawNumber === itemData.drawNumber);
    jackpotAmount = jackpot && ((_jackpot$jackpots = jackpot.jackpots) === null || _jackpot$jackpots === void 0 ? void 0 : _jackpot$jackpots.length) > 0 ? jackpot.jackpots[0].jackpotAmount : 0;
  }
  if (isRacing) {
    const jackpotData = jackpotsResponse === null || jackpotsResponse === void 0 ? void 0 : jackpotsResponse.turnover;
    if (jackpotData) {
      if (itemData.raceId === jackpotData.raceId) {
        jackpotAmount = parseInt(jackpotData.jackpot, 10) > 0 ? jackpotData.jackpot : 0;
      } else {
        logger.info("Warning: Expected turnover-data to match raceId (".concat(jackpotData.raceId, " != ").concat(itemData.raceId, ")"));
      }
    }
  }
  return parseInt(jackpotAmount || 0, 10) > 0 ? "Jackpot: ".concat(formatCurrencyInMillions(jackpotAmount), " milj kr") : null;
}

function _getFundText(_ref9) {
  let itemData = _ref9.itemData;
  const formatCurrency = format.Currency;
  if (itemData.fund) {
    const extraMoney = formatCurrency(itemData.fund.extraMoney);
    const rolloverIn = formatCurrency(itemData.fund.rolloverIn);
    if (extraMoney !== '0') {
      return "Extrapengar: ".concat(extraMoney, " kr");
    }
    if (rolloverIn !== '0') {
      return "Rullpott: ".concat(rolloverIn, " kr");
    }
  }
  return null;
}

function _getNetsaleText(_ref0) {
  let isDraw = _ref0.isDraw,
    isRacing = _ref0.isRacing,
    itemData = _ref0.itemData,
    jackpotsResponse = _ref0.jackpotsResponse;
  const formatCurrency = format.Currency;
  let value;
  if (isDraw) {
    value = itemData.currentNetSale || itemData.currentNetSales;
  }
  if (isRacing) {
    const jackpotData = jackpotsResponse === null || jackpotsResponse === void 0 ? void 0 : jackpotsResponse.turnover;
    if (jackpotData) {
      if (itemData.raceId === jackpotData.raceId) {
        value = jackpotData.turnover;
      } else {
        logger.info("Warning: Expected turnover-data to match raceId (".concat(jackpotData.raceId, " != ").concat(itemData.raceId, ")"));
      }
    }
  }
  return parseInt(value || 0, 10) > 0 ? "Oms\xE4ttning: ".concat(formatCurrency(value), " kr") : null;
}

if (svs.isServer) {
  module.exports = extractEventItems;
} else {
  setGlobal('svs.components.sport.eventByProductListWidget', {
    extractEventItems
  });
}

 })(window);